module.exports = __webpack_public_path__ + "components/flag/static/square/qa-7882555f73c151e241989772dde0a9ce.svg";